/**
 * An object containing properties for copy events
 */
export class CopyEvent {
  /**
   * The copied value
   */
  value: string;
}
